import { render } from "./FlirtArchive.vue?vue&type=template&id=3ba3a1c7&scoped=true&ts=true"
import script from "./FlirtArchive.vue?vue&type=script&lang=ts"
export * from "./FlirtArchive.vue?vue&type=script&lang=ts"

import "./FlirtArchive.vue?vue&type=style&index=0&id=3ba3a1c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba3a1c7"]])

export default __exports__